import LunchOrder from './pages/LunchOrder'
import LunchSummary from './pages/LunchSummary'
import Accounting from './pages/Accounting'
import Administration from './pages/Administration'
import Logout from "./pages/Logout";

export default {
    host: "https://los.green.cz/api",
    //host: "http://localhost:8080",
    //relogRedirect: "https://los.green.cz",
    relogRedirect: "http://localhost:8080",
    keycloakOptions: {
        //url: 'https://los.green.cz:8180/auth',
        url: 'https://keycloak.greencenter.site/auth',
        realm: 'green',
        clientId: 'lunch_web',
        onLoad:'login-required',
        //onLoad:'check-sso',
        bearerOnly: true
    },
    routes: [
        {path: '/', component: LunchOrder},
        {path: '/summary', component: LunchSummary},
        {path: '/accounting', component: Accounting},
        {path: '/administration', component: Administration},
        {path: '/logout', component: Logout}
    ]
}